/**
 * GT Blog — load more via Section Rendering API + Client-side Sorting.
 */
(function () {
  'use strict';

  /**
   * @param {HTMLElement} root
   */
  function initGtBlog(root) {
    if (!root || root.dataset.gtBlogInit === 'true') return;

    var grid = root.querySelector('[data-gt-blog-grid]');
    var itemsWrap = root.querySelector('[data-gt-blog-items]');
    var button = root.querySelector('[data-gt-blog-load-more]');
    var sortSelect = document.getElementById('GtBlogSort'); // Lấy phần tử select sort

    if (!grid || !itemsWrap || !button) return;

    var sectionId = root.dataset.sectionId;
    var blogUrl = root.dataset.blogUrl;
    if (!sectionId || !blogUrl) return;

    var spinner = button.querySelector('.loading__spinner');
    var sectionSelector = '#GtBlog-' + sectionId;

    root.dataset.gtBlogInit = 'true';

    /**
     * Hàm xử lý sắp xếp lại toàn bộ các bài viết đang hiển thị trên DOM
     */
    function applySort() {
      if (!sortSelect || !itemsWrap) return;
      var sortValue = sortSelect.value;
      var items = Array.from(itemsWrap.querySelectorAll('.gt-blog-item-sortable'));

      items.sort(function (a, b) {
        if (sortValue === 'date-desc') {
          return parseInt(b.getAttribute('data-date')) - parseInt(a.getAttribute('data-date'));
        } else if (sortValue === 'date-asc') {
          return parseInt(a.getAttribute('data-date')) - parseInt(b.getAttribute('data-date'));
        } else if (sortValue === 'title-asc') {
          return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        } else if (sortValue === 'title-desc') {
          return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
        }
        return 0;
      });

      // Xóa cũ và chèn lại theo thứ tự mới đã sort
      itemsWrap.innerHTML = '';
      items.forEach(function (item) {
        itemsWrap.appendChild(item);
      });
    }

    /**
     * @param {boolean} isLoading
     */
    function setLoading(isLoading) {
      if (isLoading) {
        button.disabled = true;
        button.classList.add('loading');
        button.setAttribute('aria-busy', 'true');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    // Lắng nghe sự kiện thay đổi dropdown Sort của người dùng
    if (sortSelect) {
      sortSelect.addEventListener('change', applySort);
    }

    // Sự kiện bấm nút See More
    button.addEventListener('click', function () {
      var nextPage = button.getAttribute('data-next-page');
      if (!nextPage || button.disabled) return;

      setLoading(true);

      // Đồng bộ giữ nguyên tag lọc hiện tại trên URL nếu có
      var fetchUrl = new URL(window.location.href);
      fetchUrl.searchParams.set('page', nextPage);
      fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load more articles');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sectionEl = doc.querySelector(sectionSelector);
          var newItemsRoot = sectionEl
            ? sectionEl.querySelector('[data-gt-blog-items]')
            : doc.querySelector('[data-gt-blog-items]');

          if (!newItemsRoot) {
            throw new Error('Could not find blog items in response');
          }

          // Nhặt các thẻ wrapper sortable mới được tải về và append vào danh sách hiện tại
          newItemsRoot.querySelectorAll('.gt-blog-item-sortable').forEach(function (item) {
            itemsWrap.appendChild(item);
          });

          // KÍCH HOẠT LẠI HÀM SORT để sắp xếp lại bao gồm cả các bài viết vừa tải về
          applySort();

          var newButton = sectionEl
            ? sectionEl.querySelector('[data-gt-blog-load-more]')
            : doc.querySelector('[data-gt-blog-load-more]');
          var next = newButton && newButton.getAttribute('data-next-page');

          if (next) {
            button.setAttribute('data-next-page', next);
            setLoading(false);
            button.disabled = false;
          } else {
            var actions = root.querySelector('[data-gt-blog-actions]');
            if (actions) actions.remove();
          }
        })
        .catch(function (err) {
          console.error(err);
          setLoading(false);
          button.disabled = false;
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gt-blog]').forEach(initGtBlog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLElement)) return;
    var section = target.querySelector('[data-gt-blog]');
    if (section instanceof HTMLElement) {
      delete section.dataset.gtBlogInit;
      initGtBlog(section);
    }
  });
})();